'use strict';
const trackingUtils = require('../modules/utils/tracking.utils');
const trackingPageFlowUtils = require('../modules/utils/flow_tracking/tracking.page.flow.utils');

const retryPageFlowTracking = (type, label) => ({
    flow: `payment_flow_${type}`,
    label: `retry:${label}`,
});

const retryPageFlowTrackingType = {
    ACTION: 'action',
    APPEARANCES: 'appearances',
};

Odigeo.defineWidget('error_message_layer', Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend({
        defaults: {
            error: null,
        },
    }),
    viewClass: Odigeo.View.extend({
        events: {
            'tap .dialog_close_hint_icon': 'closeWindow',
            'tap .try_again': 'tryAgain',
            'tap .pay_transfer': 'payTransfer',
        },

        selectors: {
            errorContainer: '.errormessage_container',
            errorTitle: '.error_title',
            errorSubtitle: '.error_subtitle',
        },

        init: function() {
            this.$cachedSelectors.paymentManager = $('#payment-manager');
        },

        trackMessageLayer: function(labelEvent) {
            var category = this.widget.options.isDynpack ? 'dynpack_pay_page' : 'flights_pay_page';
            var action = 'payment_error_popup';
            var label = 'pay_error_popup_' + this.model.get('error') + '_' + labelEvent;
            trackingUtils.trackEventWithCategory(category, action, label);
        },

        closeWindow: function() {
            this.$cachedSelectors.errorContainer.addClass('odf-hidden');
            this.trackMessageLayer('close');
            trackingPageFlowUtils.launchEvent(retryPageFlowTracking(retryPageFlowTrackingType.ACTION, 'close'));
        },

        tryAgain: function() {
            this.$cachedSelectors.errorContainer.addClass('odf-hidden');
            Odigeo.Utils.scrollToElement(this.$cachedSelectors.paymentManager);
            this.trackMessageLayer('try_again');
            trackingPageFlowUtils.launchEvent(retryPageFlowTracking(retryPageFlowTrackingType.ACTION, 'OK'));
        },

        setErrorMessages: function(errorType) {
            var obj = this.widget.options.translations.errorType[errorType];
            this.$cachedSelectors.errorTitle.html(obj.errorTitle);
            this.$cachedSelectors.errorSubtitle.html(obj.errorSubtitle);
        },

    }),

    manageError: function(error) {
        if (Odigeo._.startsWith(error, 'COLLECTION_')) {
            this.model.set('error', error);
            this.view.setErrorMessages(error);
            this.view.$cachedSelectors.errorContainer.removeClass('odf-hidden');
            this.view.trackMessageLayer('loaded');
            trackingPageFlowUtils.launchEvent(retryPageFlowTracking(retryPageFlowTrackingType.APPEARANCES, 'ap'));
        }
    },

}));
